import { IUserPreferences } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { UserPreferencesAction } from '../actions/userPreferencesAction';

export const userPreferencesReducer = (userPreferences: IUserPreferences, action: UserPreferencesAction): IUserPreferences => {
    switch (action.type) {
        case 'SET_USER_PREFERENCES':
            // Shows at most 4 GPTs (+ SyGPT) pinned
            if (action.payload.addedGpts?.length! >= 4) {
                return {
                    ...userPreferences,
                    ...action.payload,
                    addedGpts: action.payload.addedGpts?.slice(-4)
                }
            }
            else {
                return { ...userPreferences, ...action.payload };
            }
        default:
            return userPreferences;
    }
};
